import helpers from 'src/helpers/'

export default {
  tableModuleList: state => {
    return state.moduleList
  },
  tableDataRoleGroup: state => {
    return state.roleGroupList
  },
  tableDataRoles: state => {
    return state.roleList
  },
  tableMasterList: state => {
    return state.mastersList
  },
  tableMasterDataList: state => {
    return state.mastersDataList
  },
  tableUsersList: state => {
    return state.usersList
  },
  userListSearchResult: state => {
    let result = {
      list: [],
    }
    if (typeof state.usersList !== 'undefined') {
      if (
        typeof state.usersList.list !== 'undefined' &&
        state.usersList.list !== null &&
        typeof state.usersList.list.data !== 'undefined' &&
        state.usersList.list.data !== null
      ) {
        result.list = state.usersList.list.data.map(opt => ({
          label: opt.name,
          value: opt.id,
          user_type_id: opt.user_type_id,
          email: state.email,
        }))
      }
    }
    return result
  },
  getEnrollmentTypes: state => {
    let list = helpers.getValue(state, 'enrollmentTypeList.list', [])
    return list.map(opt => ({
      label: opt.title,
      value: opt.id,
    }))
  },
  getStateListOptions: state => {
    let list = helpers.getValue(state, 'stateList.list.data', [])
    return list.map(opt => ({
      label: opt.name,
      value: opt.id,
    }))
  },
  getCityListOptions: state => {
    let list = helpers.getValue(state, 'cityList.list.data', [])
    return list.map(opt => ({
      label: opt.name,
      value: opt.id,
    }))
  },
  tableDataStockLocations: state => {
    return state.stockLocationList
  },
  tableDataZones: state => {
    return state.zoneList
  },
  tableDataTaxes: state => {
    return state.taxList
  },
  tableDataDeliveryCharges: state => {
    return state.deliveryChargeList
  },
  reportConfigsList: state => {
    return state.reportConfigsList
  },
  tableSubscriptionPlanList: state => {
    return state.memberShipRoleList
  },
  getAllMemberShipRoleList: state => {
    return state.memberShipRoleList.list.data
  },
  getModuleList: state => {
    return state.moduleList.list.data
  },
  getRoleGroupOptions: state => {
    return state.roleGroupList.list.data.map(x => {
      return {
        value: x.id,
        label: x.title,
      }
    })
  },
  tableDepartmentList: state => {
    return state.departmentList
  },
  getDepartmentOptions: state => {
    return state.departmentOptions.data.options
  },
  getLocationsOptions: state => {
    return state.locationsOptions.data.options
  },
  getBuilderRoleByID: state => id => {
    let builderRole = state.memberShipRoleList.list.data.find(x => x.id === id)
    if (builderRole !== undefined) {
      return builderRole
    }
    return { permissions: { ids: [] } }
  },
  tableCurrenciesConversionsList: state => {
    return state.currencyConversionList
  },
  getCurrencyListOptions: state => {
    let list = helpers.getValue(state, 'currencyList.list.data', [])
    return list.map(opt => ({
      label: `${opt.name} (${opt.code})`,
      value: opt.id,
    }))
  },
}
